export default __webpack_public_path__ + "static/media/bg10.cc29b59f.jpg";